// menu
"use strict";

(function() {
  var MenuToggler = $(".header--hamburger").click(function(e) {
    $(this).toggleClass("__jsActive");
    $(this).parents().find(".header--nav").toggleClass("__jsActive");
  });
  $(".header").on("mouseleave", function() {
    $(this)
        .parents().find(".header--nav").removeClass("__jsActive");
      $(this)
        .parents().find(".header--hamburger").removeClass("__jsActive");
  });
  $(".header li").on("click", function() {
    $(this)
        .parents().find(".header--nav").removeClass("__jsActive");
      $(this)
        .parents().find(".header--hamburger").removeClass("__jsActive");
  });
})();


//dodanie klasy do header po scrollu

var $D = $(document).scrollTop();
var checkIfAddBg = function(){
    
  if ($D < 100) {
    $('header.header').removeClass('__jsFixed');
  } else {
    $('header.header').addClass('__jsFixed');
  }   
};

checkIfAddBg();

$(document).scroll(function() {
    $D = $(document).scrollTop();
    checkIfAddBg();
});
